// tslint:disable
/**
 * GetInfo
 * Get info api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { Course } from './course';
import { User } from './user';

/**
 * 
 * @export
 * @interface CourseListener
 */
export interface CourseListener {
    /**
     * 
     * @type {string}
     * @memberof CourseListener
     */
    id: string;
    /**
     * 
     * @type {User}
     * @memberof CourseListener
     */
    user: User;
    /**
     * 
     * @type {Course}
     * @memberof CourseListener
     */
    course: Course;
    /**
     * 
     * @type {boolean}
     * @memberof CourseListener
     */
    enabled: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CourseListener
     */
    success?: boolean | null;
    /**
     * 
     * @type {Date}
     * @memberof CourseListener
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof CourseListener
     */
    passedAt?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof CourseListener
     */
    learningCompleted: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CourseListener
     */
    testCompleted: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CourseListener
     */
    practiceCompleted: boolean;
    /**
     * 
     * @type {string}
     * @memberof CourseListener
     */
    status: CourseListenerStatusEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum CourseListenerStatusEnum {
    Learning = 'learning',
    Success = 'success',
    NotSuccess = 'not_success'
}



